import { useContext, useEffect, useRef, useState } from 'react';
import './App.css';
import Fabric from './components/fabric';
import './components/main.css'

import Suits from './components/Suits';

import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import Left_panel from './components/left_panel';
import View_Fabric from './components/ViewFabric';
import Order_page from './components/order_page';
import UpdateFabric from './components/updatingFabrics';
import AddBrand from './components/addBrand';
import Presets_upload from './components/Presets';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from './Firebase/AuthProvider';
import Presets_view from './components/presets_view';
import Button_upload from './components/buttons';
import Tuxedo_upload from './components/tuxedo';
import EmbroideryForm from './components/Embroidery';
import Embroidery_collection from './components/embroidary_collection';
import Embroidery_style from './components/embroidery_style';
import Piping_upload from './components/piping';
import NotificationsPage from './components/notifications';
import CallSchedulePage from './components/call_schedule';
import SupportRequestsPage from './components/support_requests';
import ReviewsPage from './components/reviews';
import Campus_orders from './components/campus_orders';
import Fabric_purchase from './components/fabric_purchase';
import Campus_packing from './components/campus_packing';
import AnalyticsPage from './components/analytics';
import DesignRequestsPage from './components/design_requests';
import StylePages from './components/style_pages';
import UniformUpload from './components/uniform_upload';
import UniformOrders from './components/uniform_orders';
import TaxBillPage from './components/tax_bill';
import CouponsPage from './components/coupons';
import BusinessesPage from './components/businesses';
import CarePage from './components/care';

function Admin() {
  
  const {user} = useContext(AuthContext)

  
  const [current, setCurrent] = useState(1)
  const [edit, setEdit] = useState()

  
  const [styleModal, setStyleModal] = useState({})
  const {id} = useParams()

  const [modalopac, setModalOpac] = useState(false)


  const navigate = useNavigate()

  useEffect(()=>{
    setEdit(null)
    setCurrent( parseInt(id) )
  }, [id])
  const T = [
    "Orders",
    "Notifications",
    "Upload Fabric",
    "Edit Fabric",
    "Upload Outfit",
    "Edit Outfit", 
    "Add Brand", 
    "Upload Product",
    "View Product",
    "Upload Button", 
    "Tuxedo",
    "Piping",
    "Embroidery Style",
    "Embroidery Render",
    "Embroidery Collection",
    "Dashboard", 
    "Call Schedule",
    "Support",
    "Review",
    "Campus Orders",
    "Fabric Purchase",
    "Packing",
    "Logout",
    "Analytics",
    "Design Photos",
    "Style Pages",
    "Upload Uniform",
    "Uniform Orders",
    "Coupons",
    "Business Accounts",
    "Care",
    "Tax Invoice"
  ]
  return (
    <div className="App">
      {/* <Fabric/> */}
      <Left_panel
        set = {setCurrent}
        T  = {T}
        current = {current}
      />
      <div className={`right ${(current >= 0 && current <= 24) ? "right-with-topbar" : ""} ${(current === 3 || current === 5) ? "right-with-filterbar" : ""}`}>



        {modalopac && <div className='opac_bg'>

        </div>}
        {current === 0 ? (
          <div className="page-topbar">
            <h2>Orders</h2>
          </div>
        ) : current === 1 ? (
          <div className="page-topbar">
            <h2>Notifications</h2>
          </div>
        ) : current === 2 ? (
          <div className="page-topbar">
            <h2>Upload Fabric</h2>
          </div>
        ) : current === 3 ? (
          <div className="page-topbar">
            <h2>Edit Fabric</h2>
          </div>
        ) : current === 4 ? (
          <div className="page-topbar">
            <h2>Upload Outfit</h2>
          </div>
        ) : current === 5 ? (
          <div className="page-topbar">
            <h2>Edit Outfit</h2>
          </div>
        ) : current === 9 ? (
          <div className="page-topbar">
            <h2>Upload Button</h2>
          </div>
        ) : current === 6 ? (
          <div className="page-topbar">
            <h2>Add Brand</h2>
          </div>
        ) : current === 7 ? (
          <div className="page-topbar">
            <h2>Upload Product</h2>
          </div>
        ) : current === 8 ? (
          <div className="page-topbar">
            <h2>View Product</h2>
          </div>
        ) : current === 10 ? (
          <div className="page-topbar">
            <h2>Upload Tuxedo</h2>
          </div>
        ) : current === 11 ? (
          <div className="page-topbar">
            <h2>Upload Piping</h2>
          </div>
        ) : current === 12 ? (
          <div className="page-topbar">
            <h2>Embroidery Style</h2>
          </div>
        ) : current === 13 ? (
          <div className="page-topbar">
            <h2>Embroidery Render</h2>
          </div>
        ) : current === 14 ? (
          <div className="page-topbar">
            <h2>Embroidery Collection</h2>
          </div>
        ) : current === 15 ? (
          <div className="page-topbar">
            <h2>Dashboard</h2>
          </div>
        ) : current === 16 ? (
          <div className="page-topbar">
            <h2>Call Schedule</h2>
          </div>
        ) : current === 17 ? (
          <div className="page-topbar">
            <h2>Support</h2>
          </div>
        ) : current === 18 ? (
          <div className="page-topbar">
            <h2>Review</h2>
          </div>
        ) : current === 19 ? (
          <div className="page-topbar">
            <h2>Campus Orders</h2>
          </div>
        ) : current === 20 ? (
          <div className="page-topbar">
            <h2>Fabric Purchase &amp; Stock</h2>
          </div>
        ) : current === 21 ? (
          <div className="page-topbar">
            <h2>Packing</h2>
          </div>
        ) : current === 23 ? (
          <div className="page-topbar">
            <h2>Website Analytics</h2>
          </div>
        ) : current === 24 ? (
          <div className="page-topbar">
            <h2>Design Photos</h2>
          </div>
        ) : current === 25 ? (
          <div className="page-topbar">
            <h2>Style Pages</h2>
          </div>
        ) : current === 26 ? (
          <div className="page-topbar">
            <h2>Upload Uniform</h2>
          </div>
        ) : current === 27 ? (
          <div className="page-topbar">
            <h2>Uniform Orders</h2>
          </div>
        ) : (
          <h2>{T[current]}</h2>
        )}
        {current === 2 ? (<Fabric edit={edit} setEdit={setEdit}/>)
        : current === 3 ? (<View_Fabric setCurrent={setCurrent} setEdit={setEdit}/>)
        : current === 4 ? (<Suits edit={edit} setEdit={setEdit}/>)
        : current === 0 ? (<>
          <Order_page
            current={current}
          />
        </>)
        : current === 1 ? (<>
          <NotificationsPage />
        </>)
        : current === 6 ? (<AddBrand/>)
        : current === 7 ? (
        <Presets_upload edit={edit} setEdit={setEdit} setModalOpac = {setModalOpac}/>) 
        : current === 8 ? <Presets_view/>
        : current === 9 ? (
          <Button_upload/>)
        : current === 10 ? (
          <Tuxedo_upload/>
        )
        : current === 11 ? (
          <Piping_upload/>
        )
        : current === 12 ? (
          <Embroidery_style/>
        )
        : current === 13 ? (
          <EmbroideryForm/>
        )
        : current === 14 ? (
          <Embroidery_collection/>
        )
        : current === 15 ? (
          <div className="dash-home">
            <p className="dash-kicker">MAVIINCI Admin</p>
            <h3 className="dash-title">Quick access</h3>
            <div className="dash-grid">
              {[
                ["Orders", 0, "🧾"],
                ["Campus Orders", 19, "🎓"],
                ["Uniform Orders", 27, "👕"],
                ["Packing", 21, "📦"],
                ["Fabric Purchase", 20, "🧵"],
                ["Notifications", 1, "🔔"],
                ["Design Photos", 24, "📷"],
                ["View Product", 8, "👔"],
                ["Call Schedule", 16, "☎"],
                ["Support", 17, "🎧"],
                ["Coupons", 28, "🎟"],
                ["Business Accounts", 29, "💼"],
                ["Care", 30, "🪡"],
                ["Tax Invoice", 31, "🧮"],
              ].map(([label, idx, icon]) => (
                <button key={idx} type="button" className="dash-card" onClick={() => navigate(`/admin/${idx}`)}>
                  <span className="dash-card-icon" aria-hidden>{icon}</span>
                  <span className="dash-card-label">{label}</span>
                </button>
              ))}
            </div>
          </div>
        )
        : current === 16 ? (
          <CallSchedulePage />
        )
        : current === 17 ? (
          <SupportRequestsPage />
        )
        : current === 18 ? (
          <ReviewsPage />
        )
        : current === 19 ? (
          <Campus_orders current={current} />
        )
        : current === 20 ? (
          <Fabric_purchase />
        )
        : current === 21 ? (
          <Campus_packing />
        )
        : current === 23 ? (
          <AnalyticsPage />
        )
        : current === 24 ? (
          <DesignRequestsPage />
        )
        : current === 25 ? (
          <StylePages />
        )
        : current === 26 ? (
          <UniformUpload />
        )
        : current === 27 ? (
          <UniformOrders />
        )
        : current === 28 ? (
          <CouponsPage />
        )
        : current === 29 ? (
          <BusinessesPage />
        )
        : current === 30 ? (
          <CarePage />
        )
        : current === 31 ? (
          <TaxBillPage />
        )
        :(<>
          <UpdateFabric/>
        </>)
        }
        
      </div>
      
    </div>
  );
}

export default Admin;
